import { yupResolver } from '@hookform/resolvers/yup';
import React, { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { useDispatch, useSelector } from 'react-redux';

import CustomModal from '../../components/CustomModal/CustomModal';
import { IconChevronLeft } from '@tabler/icons-react';
import AnimatedComponent from '../../components/Animation/AnimatedComponent';
import { PageBody } from '../../components/SiteWrapper';
import { Col, Container, Form, Row } from 'react-bootstrap';
import Loader from '../../components/Loader';
import CollapsibleCard, { ExamDetails } from '../../components/Exam/reports';
import { ExamDetailsPerfoma } from './ExamDetailsPerfoma';
import Reports from '../Exams/Reports';

const AddEditPerfoma = ({ userModal, resetUserModal, examData }) => {
  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  const currentUserRole = authSelector.role.slug;

  const dispatch = useDispatch();

  const { id, show, title, saveBtnText, action } = userModal;
  const [isLoading, setIsLoading] = useState(false);

  return (
    <CustomModal
      show={show}
      isLoading={isLoading}
      onHide={() => resetUserModal(false)}
      modalHeading={title}
      size='md'
      saveBtnText={saveBtnText}
      //   onSaveCallback={handleSubmit(formSubmit)}
      hadBodyPadding
    >
      <Fragment>
        {console.log('examData', examData)}
        <AnimatedComponent
          as={PageBody}
          className={`mt-0 ${examData?.submitted ? 'mb-0' : ''}`}
        >
          <Reports />
          {/* {isLoading && <Loader />}

          <p className='text-muted'>
            You can SAVE the report multiple times throught the day. Once you're
            done with your day, you can SUBMIT it only once.
          </p>
          <Form autoComplete='off'>
            {examData && (
              <CollapsibleCard defaultOpen={false} title='Exam Info'>
                <ExamDetailsPerfoma examData={examData} />
              </CollapsibleCard>
            )}
          </Form> */}
          {/* </Container> */}
        </AnimatedComponent>
      </Fragment>
    </CustomModal>
  );
};

export default AddEditPerfoma;
